import { makeRequest } from 'utils/requestLogger';

export default (id) =>
    makeRequest(
        'post',
        `/api/courses/${id}/get_student_skills/me`
    ).then((res) => res.data);


// WEBPACK FOOTER //
// ./src/app/services/courses/getMyStudentSkills.js